export default "/images/contrivio-icon.svg?d794f6e78f852b8899c63783408d1a59";